'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UserHeaderNav = require('./components/UserHeaderNav.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UserHeaderNav).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-header/lib/components/user-header-nav/index.js
// module id = 1554
// module chunks = 1